<!-- @format -->

<ng-container *transloco="let t">
  <fudis-dialog [size]="'sm'">
    <fudis-heading [level]="2" fudisDialogTitle>{{ data.modalTitle | transloco }}</fudis-heading>
    <fudis-dialog-content>
      <fudis-grid [classes]="'fudis-my-md'">
        <fudis-body-text [variant]="'md-light'">{{ data.infoText | transloco }}</fudis-body-text>
        <fudis-body-text [variant]="'md-light'">{{ data.infoQuestion | transloco }}</fudis-body-text>
        <a fudisLink [href]="getLocalizedSurveyUrl()" [external]="true" [title]="data.continueButtonText | transloco"></a>
      </fudis-grid>
    </fudis-dialog-content>
    <fudis-dialog-actions>
      <fudis-button fudisDialogClose [label]="t('SIS_COMPONENTS.BUTTON.CLOSE')" (handleClick)="closeSurveyDialog()" />
    </fudis-dialog-actions>
  </fudis-dialog>
</ng-container>
